export var Platform;
(function (Platform) {
    Platform[Platform["MEITUAN"] = 1] = "MEITUAN";
    Platform[Platform["DIANPING"] = 2] = "DIANPING";
})(Platform || (Platform = {}));
// 来源枚举
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    Source[Source["WECHAT_MEITUAN_MINIAPP"] = 3] = "WECHAT_MEITUAN_MINIAPP";
    Source[Source["WECHAT_HOTEL_MINIAPP"] = 4] = "WECHAT_HOTEL_MINIAPP";
    Source[Source["WECHAT_DIANPING_MINIAPP"] = 5] = "WECHAT_DIANPING_MINIAPP";
})(Source || (Source = {}));
// 客户端类型枚举
export var ClientType;
(function (ClientType) {
    ClientType[ClientType["IPHONE"] = 1] = "IPHONE";
    ClientType[ClientType["ANDROID"] = 2] = "ANDROID";
    ClientType[ClientType["WX"] = 3] = "WX";
})(ClientType || (ClientType = {}));
